var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-5/6 flex flex-row justify-center items-center"},[_c('h1',{staticClass:"text-light text-2xl"},[_vm._v("\n    Validating Successful Order\n  ")]),_c('xn-waiting',{attrs:{"show":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }